import { render } from "./SoftwareIntro.vue?vue&type=template&id=0daa6658&scoped=true"
import script from "./SoftwareIntro.vue?vue&type=script&lang=js"
export * from "./SoftwareIntro.vue?vue&type=script&lang=js"

import "./SoftwareIntro.vue?vue&type=style&index=0&id=0daa6658&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0daa6658"]])

export default __exports__